import { useEffect, useState } from 'react';
import { FlagsObject } from 'src/types/featureFlags';

export const flagKeys = [
  'PF_Upgrade_SKUs',
  'PF_RecommendedPrinterUpgradeRules',
  'PF_enableFullUpgrade'
];

const useFlags = () => {
  const [flags, setFlags] = useState<Partial<FlagsObject>>({});
  const [error, setError] = useState(null);

  const fetchFlags = async () => {
    try {
      const client = await window.Shell.v1.featureFlags.getClient(
        'post-enrollment-aip'
      );

      const results = await Promise.all(
        flagKeys.map((key) =>
          client.getFeatureFlag({ key, defaultValue: false })
        )
      );

      const flagsObject = flagKeys.reduce(
        (acc, key, idx) => {
          acc[key] = results[idx];
          return acc;
        },
        {} as Record<string, boolean>
      );

      setFlags(flagsObject);
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    fetchFlags();
  }, []);

  return { flags, error };
};

export default useFlags;
